var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"csn-live-tag"},[_c('cs-tag',{staticClass:"csn-live-tag__tag"},[_c('span',{staticClass:"csn-live-tag__dot"}),_vm._v("On Air")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }